import React, { useState } from 'react';
import './AltFooterNew.css';

const BLUE   = '#0A93F5';
const VIOLET = '#7B5BFF';

const NAV = {
  product: [
    { label: 'Sell Content',   href: '/sell' },
    { label: 'Post on Premsi', href: '/postonpremsi' },
    { label: 'For Creators',   href: '/invitation' },
    { label: 'Calculator',     href: '/calculator' },
    { label: 'Download App',   href: '/download' },
  ],
  learn: [
    { label: 'What is Premsi?', href: '/presentation' },
    { label: 'How it works',    href: '/explanation' },
    { label: 'Ambassador',      href: '/ambassador' },
    { label: 'FAQ',             href: '/faq' },
  ],
  legal: [
    { label: 'Terms of Service',     href: '/termsofservice' },
    { label: 'Privacy Policy',       href: '/privacypolicy' },
    { label: 'Community Guidelines', href: '/communityguidelines' },
  ],
};

// ── sparkle (used decoratively only — not as logo) ────────────────────────────
function SparkSVG({ size = 16, color = '#fff' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill={color} aria-hidden="true">
      <path d="M50 6C55 40 60 45 94 50C60 55 55 60 50 94C45 60 40 55 6 50C40 45 45 40 50 6Z"/>
      <path d="M83 14C84 20 85 21 91 22C85 23 84 24 83 30C82 24 81 23 75 22C81 21 82 20 83 14Z" opacity=".6"/>
    </svg>
  );
}

// ── social icons ──────────────────────────────────────────────────────────────
function IgSVG() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="2" width="20" height="20" rx="5.5"/>
      <circle cx="12" cy="12" r="4.5"/>
      <circle cx="17.7" cy="6.3" r="1.2" fill="currentColor" stroke="none"/>
    </svg>
  );
}
function TikTokSVG() {
  return (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.08-.14 1.62.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  );
}
function XSVG() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}

// ── logo lockup — uses actual Premsi logo image, not spark ───────────────────
function LogoLockup({ size = 'lg' }) {
  const imgSize  = size === 'lg' ? 32 : 24;
  const wordSize = size === 'lg' ? 26 : 20;
  const gap      = size === 'lg' ? 11 : 8;
  return (
    <div className="afn-logo">
      <img
        src={require('../../images/pblue-min.webp')}
        alt="Premsi logo"
        width={imgSize}
        height={imgSize}
        className="afn-logo__img"
      />
      <span className="afn-logo__word" style={{ fontSize: wordSize, gap }}>
        premsi
      </span>
    </div>
  );
}

// ── social button ─────────────────────────────────────────────────────────────
const SOCIAL_HREFS = {
  Instagram:    'https://www.instagram.com/premsi.com_/',
  TikTok:       'https://www.tiktok.com/@premsi',
  'X (Twitter)':'https://twitter.com/PremsiCom',
};

function SocialBtn({ children, label }) {
  const [h, setH] = useState(false);
  return (
    <a
      href={SOCIAL_HREFS[label] || '#'}
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
      className={`afn-social${h ? ' afn-social--hover' : ''}`}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
    >
      {children}
    </a>
  );
}

// ── footer link ───────────────────────────────────────────────────────────────
function FLink({ label, href }) {
  const [h, setH] = useState(false);
  return (
    <a
      href={href || '#'}
      className={`afn-flink${h ? ' afn-flink--hover' : ''}`}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
    >
      {h && <span className="afn-flink__arrow">›</span>}
      {label}
    </a>
  );
}

// ── link column ───────────────────────────────────────────────────────────────
function LinkCol({ title, links }) {
  return (
    <div className="afn-linkcol">
      <div className="afn-linkcol__title">{title}</div>
      <div className="afn-linkcol__links">
        {links.map((l) => <FLink key={l.label} label={l.label} href={l.href} />)}
      </div>
    </div>
  );
}

// ── pre-footer CTA strip ──────────────────────────────────────────────────────
function PreFooter() {
  const [hPrimary, setHP] = useState(false);
  const [hSec,     setHS] = useState(false);
  return (
    <div className="afn-prefooter">
      {/* ambient glow */}
      <div aria-hidden="true" className="afn-prefooter__glow" />
      {/* dot grid */}
      <div aria-hidden="true" className="afn-prefooter__dots" />

      <div className="afn-prefooter__content">
        <LogoLockup size="lg" />

        <h2 className="afn-prefooter__headline">
          Ready to earn more<br/>
          <span className="afn-prefooter__headline-grad">from your content?</span>
        </h2>

        <p className="afn-prefooter__sub">
          The AI works 24/7. You keep 90%. Start in 30 seconds.
        </p>

        <div className="afn-prefooter__ctas">
          <a
            href="/invitation"
            className={`afn-cta-primary${hPrimary ? ' afn-cta-primary--hover' : ''}`}
            onMouseEnter={() => setHP(true)}
            onMouseLeave={() => setHP(false)}
          >
            <SparkSVG size={14} color="#fff" />
            Start for free
          </a>
          <a
            href="/download"
            className={`afn-cta-secondary${hSec ? ' afn-cta-secondary--hover' : ''}`}
            onMouseEnter={() => setHS(true)}
            onMouseLeave={() => setHS(false)}
          >
            Download app
            <span className="afn-cta-secondary__arrow">↓</span>
          </a>
        </div>
      </div>
    </div>
  );
}

// ── main footer ───────────────────────────────────────────────────────────────
function MainFooter() {
  return (
    <div className="afn-main">
      <div className="afn-main__grid">
        {/* brand column */}
        <div className="afn-brand-col">
          <LogoLockup size="sm" />
          <p className="afn-brand-col__tagline">
            Create. Enjoy. Share. Earn.<br/>All in one place.
          </p>
          <div className="afn-brand-col__socials">
            <SocialBtn label="Instagram"><IgSVG /></SocialBtn>
            <SocialBtn label="TikTok"><TikTokSVG /></SocialBtn>
            <SocialBtn label="X (Twitter)"><XSVG /></SocialBtn>
          </div>
          {/* AI badge */}
          <div className="afn-ai-badge">
            <SparkSVG size={11} color={VIOLET} />
            <span className="afn-ai-badge__label">Best AI Monetization Tools</span>
          </div>
        </div>

        <LinkCol title="Product" links={NAV.product} />
        <LinkCol title="Learn"   links={NAV.learn}   />
        <LinkCol title="Legal"   links={NAV.legal}   />
      </div>

      {/* bottom bar */}
      <div className="afn-bottom">
        <span className="afn-bottom__copy">© 2026 Premsi. All rights reserved.</span>
        <span className="afn-bottom__tagline">
          <SparkSVG size={10} color="rgba(255,255,255,0.25)" />
          Built for creators who deserve more.
        </span>
      </div>
    </div>
  );
}

// ── exported footer ───────────────────────────────────────────────────────────
export default function AltFooterNew() {
  return (
    <footer>
      {/* gradient rule line */}
      <div className="afn-topline" />
      {/*<PreFooter />*/}
      <MainFooter />
    </footer>
  );
}
